/* eslint-disable unicorn/filename-case -- TODO rename later */
import { clientSDK } from "@istari-frontend/api-client";
import { queryOptions } from "@tanstack/react-query";

import { modelQueryKeys } from "~/api/model/modelQueryKeys";
import { DEFAULT_CACHE_TIME } from "~/constants";

/**
 * Get base model object with all metadata and revisions
 */
export const getModelOptions = (modelId: string) =>
  queryOptions({
    queryKey: modelQueryKeys.item(modelId),
    queryFn: async () => clientSDK.getModel(modelId),
    enabled: !!modelId,
    staleTime: DEFAULT_CACHE_TIME,
  });
